import axios from 'axios';
import { api } from "../utils/config";

const add = async (data) => {
  try {

      const res = await axios.post(`${api}/tips/add`, data, {
          withCredentials: true,
      });

      if(res.data){
        return res.data
      }else{
        return res.response.data;
      }

  } catch (error) {
    throw error;
  }
};

const purchase = async (data) => {
  try {
    const res = await axios.post(`${api}/purchase`, data, { withCredentials: true });
    
    return res.data;

  } catch (error) {

    if (error.response && error.response.data) {
      return error.response.data;
    }

    throw new Error("Erro desconhecido no servidor.");
  }
};


const getTipsByChallengeId = async (id) => {
  
  try {

    const res = await axios.get(`${api}/tips/${id}`,
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

  } catch (error) {
    throw error;
  }
};

const getTipsIndexByChallengeId = async (data) => {
  
  try {

    const res = await axios.get(`${api}/tips/index/${data.userId}/${data.challengeId}`,
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

    return res;

  } catch (error) {
    throw error;
  }
};

const getTipById = async (data) => {
  
  try {

    const res = await axios.get(`${api}/purchase/${data.userId}/${data.tipId}`,
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }


  } catch (error) {
    throw error;
  }
};

const deleteTipsById = async (id) => {
  
  try {

    const res = await axios.delete(`${api}/tips/${id}`,
      {withCredentials: true},
    );

    if(res.data){
      return res.data
    }else{
      return res.response.data;
    }

  } catch (error) {
    throw error;
  }
};

const tipsService = {
  add,
  getTipsByChallengeId,
  deleteTipsById,
  getTipsIndexByChallengeId,
  purchase,
  getTipById
};

export default tipsService;